import { useCallback, useMemo, useRef, useState } from "react";

export const useInputValue = <V,>(props: { value?: V; defaultValue?: V }) => {
  const [_value, _setValue] = useState(
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    props.defaultValue === undefined ? props.value : props.defaultValue,
  );

  const isControlled = useRef(
    Object.prototype.hasOwnProperty.call(props, "value"),
  );

  // controlledの場合、表示値は常にprops.valueが優先されるため、
  // 内部stateの更新は不要な再レンダリングをキューするだけになる。それを抑制する。
  const setValue: typeof _setValue = useCallback((next) => {
    if (isControlled.current) {
      return;
    }
    _setValue(next);
  }, []);

  const value = useMemo(() => {
    // eslint-disable-next-line react-hooks/refs
    if (isControlled.current === false) {
      return _value;
    }
    return _value === props.value ? _value : props.value;
  }, [_value, props.value]);

  // eslint-disable-next-line react-hooks/refs
  return [value, setValue, isControlled.current] as const;
};
